import React, {Fragment} from 'react';
import {BulkDeleteButton} from 'react-admin';

export const CustomBulkActionButtons = props => (
  <Fragment>
    <BulkDeleteButton {...props} undoable="false"/>
  </Fragment>
);